import { Injectable, OnDestroy, computed, inject } from '@angular/core';
import { AccessTokens, AuthCredentials } from '../../auth/schemas/auth.schema';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FireAuthService } from './fire-auth.service';
import { map, retry, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccessTokensService } from './access-tokens.service';
import { logout } from '@directus/sdk';
import { AccountsAppService } from './core/accounts-app.service';
import { PaymentsAppService } from './core/payments-app.service';
import { APPS } from '../schemas/apps.enum';
import { RequestsService } from '../utils/services/requests.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  private fireAuthService = inject(FireAuthService);
  private _destroy$ = new Subject<void>();
  private accountsAppService = inject(AccountsAppService);
  private paymentsAppService = inject(PaymentsAppService);
  private requestsService = inject(RequestsService);

  httpOptions = computed(() => {
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.fireAuthService.fireAuthToken()}`,
        'Content-Type': 'application/json',
      }),
    };
  });

  constructor(
    private http: HttpClient,
    private accessTokensService: AccessTokensService,
  ) {}

  resetPassword(credentials: AuthCredentials) {
    return this.http
      .post(
        `${environment.apiUrl}/auth/reset-password`,
        credentials,
        this.httpOptions(),
      )
      .pipe(
        retry(3),
        takeUntil(this._destroy$),
        map((response) => {
          // this.accessTokensService.set(response as AccessTokens);
          return response;
        }),
      );
  }

  // phoneAuth(credentials: AuthCredentials) {
  //   return this.http
  //     .post(`${environment.apiUrl}/auth/phone`, credentials, this.httpOptions())
  //     .pipe(
  //       retry(3),
  //       takeUntil(this._destroy$),
  //       map((response) => {
  //         // this.accessTokensService.set(response as AccessTokens);
  //         return response;
  //       }),
  //     );
  // }

  // verifyOTP(credentials: AuthCredentials) {
  //   return this.http
  //     .post(
  //       `${environment.apiUrl}/auth/verify-otp`,
  //       credentials,
  //       this.httpOptions(),
  //     )
  //     .pipe(
  //       retry(3),
  //       takeUntil(this._destroy$),
  //       map((response) => {
  //         this.accessTokensService.set(response as AccessTokens);
  //         return response;
  //       }),
  //     );
  // }

  /**
   * Logs out the user by first logging out of Directus and then from Firebase.
   * @returns A promise that resolves when the user has been logged out.
   */
  async signOut() {
    try {
      await this.accountsAppService.signOut();
      await this.paymentsAppService.signOut();

      this.accessTokensService.destroyAll();

      await this.fireAuthService.signOut();
      location.reload();
      return;
    } catch (error) {
      this.accessTokensService.destroyAll();
      await this.fireAuthService.signOut();
      location.reload();
      return;
    }
  }

  /**
   * Cleans up resources when the service is destroyed by completing the `_destroy$` subject.
   * This ensures that any ongoing HTTP requests or subscriptions are properly terminated.
   */

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
